import React from 'react';
import moment from 'moment-timezone';
import dataModel from '../../models/DataModel';
import statusService from '../../services/statusService';
import activityLogServices from '../../services/activityLogServices';

export default {
  start,
  stop,
  generateMetadatum,
  logEventHistory,
  createMetadataPhotoDisplay,
};

let _metadataInterval = null;
let _latitude = 0;
let _longitude = 0;
let _weather = null;
let _error = null;
const locationDisabledErrorText = 'User location services or GPS disabled';

function start() {
  if (!_metadataInterval || !_weather) {
    stop();
    _getLocation();
    _metadataInterval = window.setInterval(() => {
      _getLocation();
    }, 5 * 60 * 1000);
  }
}

function stop() {
  if (_metadataInterval) {
    window.clearInterval(_metadataInterval);
    _metadataInterval = null;
  }
  _weather = null;
  _latitude = 0;
  _longitude = 0;
  _error = null;
}

function generateMetadatum(config) {
  let metadatum = {};
  if (!config) {
    config = {};
  }
  if (config.exifData) {
    // assume metadata associated with picture upload...
    if (config.exifData.latitude && config.exifData.longitude) {
      metadatum.location_source = 'photo';
      metadatum.latitude = config.exifData.latitude;
      metadatum.longitude = config.exifData.longitude;
      if(config.exifData.latitude && config.exifData.longitude){
        metadatum.error = null;
      }
      else{
        metadatum.error = locationDisabledErrorText;
      }
    }
    if (config.exifData.dateTimeOriginal) {
      metadatum.local_datetime = config.exifData.dateTimeOriginal;
    }
    if (config.exifData.dateTimeOriginalOffset) {
      metadatum.local_datetime_offset = config.exifData.dateTimeOriginalOffset;
    }
  } else if (config.latitude && config.longitude) {
    metadatum.location_source = config.location_source ? config.location_source : 'device';
    metadatum.latitude = config.latitude;
    metadatum.longitude = config.longitude;
    if(config.error){
      metadatum.error = config.error;
    }
    else if(config.latitude && config.longitude){
      metadatum.error = null;
    }
    else{
      metadatum.error = locationDisabledErrorText;
    }
  }
  if (!metadatum.location_source) {
    metadatum.location_source = 'device';
    metadatum.latitude = _latitude;
    metadatum.longitude = _longitude;
    metadatum.error = _error;
  }
  if (!metadatum.local_datetime) {
    metadatum.local_datetime = config.local_datetime ? config.local_datetime : new Date();
  }
  if (config.device) {
    metadatum.device = config.device;
  } else {
    // TODO
    if (window.cordova && window.cordova.device) {
      metadatum.device = window.cordova.device.model
        + ',' + window.cordova.device.platform
        + ',' + window.cordova.device.version
        + ',' + window.cordova.device.manufacturer;
    } else {
      metadatum.device = navigator.appVersion + '|' + navigator.userAgent + '|'  + navigator.appName;
    }
  }
  if (config.user_role) {
    metadatum.user_role = config.user_role;
  } else {
    if (dataModel && dataModel.usersDAO && dataModel.usersDAO.currentUser && dataModel.usersDAO.currentUser.role) {
      metadatum.user_role = dataModel.usersDAO.currentUser.role.name;
    }
  }
  metadatum.offline = config.offline ? config.offline : !dataModel.stateTree.main.online;
  metadatum.device_type = config.device_type ? config.device_type : (dataModel.mobileBridge.isMobile ? 'mobile' : 'web');
  return metadatum;
}

function _getLocation() {
  if (navigator && navigator.geolocation) {
    navigator.geolocation.getCurrentPosition((position) => {
      if (position.coords) {
        _latitude = position.coords.latitude;
        _longitude = position.coords.longitude;
        _error = null;
      }
    },
      (error) => {
        _error = locationDisabledErrorText;
      });
  }
}

export async function logEventHistory(activityName, activitySubTypeName, body) {
  const activity = await dataModel.activitiesDAO.getActivity(activityName);
  const activity_sub_type = await dataModel.activitySubTypesDAO.getActivitySubType(activitySubTypeName, activity.id);
  activityLogServices.createActivityLogEntry(activity, activity_sub_type, body);
}

export function createMetadataPhotoDisplay(resourceAttachment) {
  if (resourceAttachment) {
    let { user, photo_taken_at, photo_latitude, photo_longitude, upload_updated_at } = resourceAttachment;
    let display = [];

    if (user) {
      display.push(
        <div className="key-val" key='0'>
          <p className="key">Uploaded by: </p>
          <p className="val">{user.first_name + ' ' + user.last_name}</p>
        </div>
      );
    }

    let createDate = null;
    let createTime = null;
    if (!photo_taken_at) {
      photo_taken_at = upload_updated_at;
    }
    if (photo_taken_at) {
      const timeZone = moment.tz.guess();
      if (photo_taken_at.created_at) {
        createDate = moment.tz(photo_taken_at.created_at, timeZone).format('MM/DD/YYYY');
        createTime = moment.tz(photo_taken_at.created_at, timeZone).format('h:mma z');
      }
      else {
        createDate = moment.tz(photo_taken_at, timeZone).format('MM/DD/YYYY');
        createTime = moment.tz(photo_taken_at, timeZone).format('h:mma z');
      }
      display.push(
        <div className="key-val" key='1'>
          <p className="key">Taken on: </p>
          <p className="val">{`${createDate ? createDate : 'Unknown'} ${createTime ? createTime : ''}`}</p>
        </div>
      );
    }

    if (photo_latitude && photo_longitude) {
      display.push(
        <div className="key-val" key='2'>
          <p className="key">Taken at: </p>
          <p className="val">{`[${photo_latitude || 'Unknown'}, ${photo_longitude || 'Unkown'}]`}</p>
        </div>
      );
    }
    return display;
  }
}



// WEBPACK FOOTER //
// ./src/helpers/metadata/Metadata.js